// extracted by mini-css-extract-plugin
var _1 = "styles-module__descriptionSection___Mywc8";
var _2 = "styles-module__editButtons___g1alI";
var _3 = "styles-module__emptyTabBtn___Gizqu";
var _4 = "styles-module__emptyTabContent___X0o1J";
var _5 = "styles-module__innerText___yp_bP";
var _6 = "styles-module__lngBtn___X2JRA";
var _7 = "styles-module__tabContent___feGhk";
export { _1 as "descriptionSection", _2 as "editButtons", _3 as "emptyTabBtn", _4 as "emptyTabContent", _5 as "innerText", _6 as "lngBtn", _7 as "tabContent" }
